export default __webpack_public_path__ + "static/media/animated-loader.c7e20d37.gif";